import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const PostSalesListing = ({
  getPostSaleListing,
  postSalesList,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
  history,
}) => {
  const headers = [
    // 'Lead Number',
    'Project Id',
    'Business Name',
    'City',
    'Created By',
    'Lead Type',
    'Lead Category',
    'Assigned To',
    'Creation On',
    // 'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  const createLead = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePostSales('contract-sales-listing');
        // setActivePostSales('post-sales-corporate');
      } else if (teamId && teamId === 9) {
        setActivePostSales('contract-sales-listing');
      } else if (teamId && teamId === 8) {
        // setActivePostSales('post-sales-apartment');
        setActivePostSales('contract-sales-listing');
        
      } else {
        setActivePostSales('post-sales-b2b-alliance');
      }
    } else if (teamId && teamId === 16) {
      setActivePostSales('contract-sales-listing');
    } else if (teamId && teamId === 21) {
      setActivePostSales('contract-sales-listing');
    }
  };

  useEffect(() => {
    localStorage.setItem('postSales', JSON.stringify(true));
    const businessListCont = JSON.parse(
      localStorage.getItem("businessListCont") &&
        localStorage.getItem("businessListCont")
    );
    if(businessListCont){
      localStorage.setItem("businessList", JSON.stringify(""));
      localStorage.setItem("businessListCont", 0);
    }
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead();
    }
  }, [teamId, departmentId]);

  useEffect(() => {
    if (getPostSaleListing !== null) {
      (async () => {
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("businessList") &&
            localStorage.getItem("businessList")
        );
        setIsLoading(true);
        const page = localStorage.getItem('page');
        if(getcontractFilter){
          await getPostSaleListing(getcontractFilter);
        } else if(page && page != null && page != 'NaN') {
          let filter = filterData === null ? null : filterData;
          await getPostSaleListing(filter,page);
        } else{
          const page = 1;
          await getPostSaleListing();
        }
        // await getPostSaleListing(null, 1);
        setIsLoading(false);
      })();
    }
  }, [getPostSaleListing]);

  useEffect(() => {
    const tableData = [
      'id',
      // 'lead_no',
      'project_id',
      'client_name',
      'city',
      'created_by',
      'lead_sub_type_name',
      'lead_category',
      'assigned_to',
      'created_at',
      // 'status',
    ];

    const actions = [
     
      // { name: 'View Follow Up', link: '/dashboard/followUp' },
      // { name: 'View POC', link: `/dashboard/viewPoc` },
    
      {
        name: 'View Contracts',
        link: `/dashboard/${activePostSales && activePostSales}`,
      },
      { name: 'Change Assignee', link: '/dashboard/assignee' },
    ];

    if (postSalesList && postSalesList.resultSets) {
      const data = postSalesList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: 
            isRoleId == 4 ?
            [
              // { name: 'View Follow Up', link: '/dashboard/followUp' },
              // { name: 'View POC', link: `/dashboard/viewPoc` },
              {
                name: 'View Contracts',
                link: `/dashboard/${activePostSales && activePostSales}/${element.lead_type_id}`,
              },
              { name: 'Change Assignee', link: '/dashboard/assignee' },
              {
                name: 'Ledger',
                link: `/dashboard/ledger-listing/${element.rb_id}`
              },
              { name: 'External User List', link: `/dashboard/external-user-list`},
            ]
            :[
              // { name: 'View Follow Up', link: '/dashboard/followUp' },
              // { name: 'View POC', link: `/dashboard/viewPoc` },
              {
                name: 'View Contracts',
                link: `/dashboard/${activePostSales && activePostSales}/${element.lead_type_id}`,
              },
              { name: 'Change Assignee', link: '/dashboard/assignee' },
              { name: 'External User List', link: `/dashboard/external-user-list`},
            ]
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(postSalesList.total / postSalesList.per_page));
    }
  }, [postSalesList]);

  const applyFilter = async (filterData) => {
    localStorage.setItem("businessList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getPostSaleListing(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(2);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const redirectToBulkAssignment = () => {
    history.push(`${baseUrl}/bulk-assignment?type=businessList`);
  }

  const headerBtns = () => {
    return (
      <Fragment>
        {isRoleId !== 9 &&
            <Button
                onClick={redirectToBulkAssignment}
                className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
            >
              <img src={Images?.Filter} alt="" />
              <b className="site_filters" style={{width:"max-content"}}>
                {localization.bulkAssignment}
              </b>
            </Button>
        }
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getPostSaleListing(filter, val.selected + 1);
    localStorage.setItem('page',val.selected + 1)
    setIsLoading(false);
  };
  
  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.postSalesLeadListing}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        detailList={postSalesList && postSalesList.resultSets}
        pageCount={pageCount}
        srNo={postSalesList?.from}
        onPageChange={onPageChange}
        currentPage={localStorage.getItem('page')}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3,4,5,6,7,8,9,10'}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        filterPreSalesListing
      />

      <ModalPop
        title={localization.updatedSuccessfully}
        show={isStatusSuccess}
        handleModalHide={closeSuccess}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadStatusupdatedsuccessfully}</h5>
          <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default PostSalesListing;
